var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header d-xl-block d-none",staticStyle:{"width":"200px"}},[_c('b-img',{attrs:{"fluid":"","src":_vm.appLogoImage,"alt":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }